module.exports = __webpack_public_path__ + "593a3d53/img/boston-lights.a623432f.png";